<template>
    <v-flex xs12 class="mt-5">
        <canvas id="platform" height="400" style="width: 100%"></canvas>
    </v-flex>
</template>

<script>
    import Chart from 'chart.js'

    export default {
        name: 'orderPlatform',
        props: ['dataPlatform'],
        mounted () {
            let ctx = document.getElementById('platform').getContext('2d')

            new Chart(ctx, {
                type: 'horizontalBar',
                data: {
                    labels: ['Платформы'],
                    datasets: [
                        {
                            label: 'Моб.прил (iOs/Android)',
                            data: [this.dataPlatform.mobile],
                            backgroundColor: ['#009600'],
                        },
                        {
                            label: 'Бот (Telegram)',
                            data: [this.dataPlatform.tg],
                            backgroundColor: ['#2B65F0']
                        },
                        {
                            label: 'Сайт',
                            data: [this.dataPlatform.site],
                            backgroundColor: ['#008e94']
                        },
                    ]
                },
                options: {
                    responsive: true,
                    legend: {
                        position: 'right',
                    },
                    title: {
                        display: true,
                        text: 'Статистика заказов по платформам'
                    }
                }
            })
        }
    }
</script>
